import useAxios from 'hooks/useAxios';
import { formatDateToLocal } from 'services/metrics';

export const getPlayers = async (limit = 20, page = 1, filters = '') => {
  const api = useAxios();
  try {
    const params = {
      limit: limit,
      page: page
    };
    if (filters && filters.search) {
      params.search = filters.search;
    }
    // if (Object.keys(filters).length) {
    //   if (filters.users.length) {
    //     params['id'] = `${filters.users.map((u) => u.id).toString()}`;
    //   }
    // }

    const unformattedData = await api.get('/getPlayersBackoffice', {
      params: params
    });
    return {
      data: unformattedData.data.data.map((x) => {
        return {
          ...x,
          client: x.client.name,
          createdAt: formatDateToLocal(x.createdAt),
          updatedAt: formatDateToLocal(x.updatedAt)
        };
      }),
      meta: unformattedData.data.meta
    };
  } catch (err) {
    console.error(err);
    return {
      data: [],
      meta: {
        totalItems: 0,
        itemCount: 0,
        itemsPerPage: 0,
        totalPages: 0,
        currentPage: 0
      }
    };
  }
};

export const getPlayerAggregated = async (user) => {
  const api = useAxios();
  try {
    const res = await api.get(`/admin/metrics/players/${user.id}`);
    return res.data.map((x) => {
      return {
        nickname: x.casino_name,
        time_spent: x.time_spent,
        current_balance: x.current_balance,
        starting_balance: x.starting_balance,
        money_spent: x.money_spent,
        money_cashed_out: x.money_cashed_out
      };
    });
  } catch (err) {
    console.error(err);
    return {
      data: [],
      meta: {
        totalItems: 0,
        itemCount: 0,
        itemsPerPage: 0,
        totalPages: 0,
        currentPage: 0
      }
    };
  }
};

export const getPlayer = async (id) => {
  const api = useAxios();
  try {
    const res = await api.get(`/admin/metrics/players/?id=${id}&isDemo=true`);
    return res.data.items[0];
  } catch (err) {
    console.error(err);
    return {
      data: [],
      meta: {
        totalItems: 0,
        itemCount: 0,
        itemsPerPage: 0,
        totalPages: 0,
        currentPage: 0
      }
    };
  }
};

export const deletePlayer = async (id) => {
  const api = useAxios();
  try {
    return await api.delete('admin/users', {
      data: { userId: id }
    });
  } catch (err) {
    console.error(`Error deleting user:`, err);
    alert(`Error deleting user: ${err.message}`);
  }
};

export const updatePlayerName = async (id, name) => {
  const api = useAxios();
  try {
    const response = await api.post('admin/users/update-nickname', {
      userId: id,
      nickname: name
    });
    if (response.status === 201) {
      console.log(`User with ID ${id} deleted successfully.`);
      alert(`Player has new name now: ${name}`);
    } else {
      console.error(`Error updating user: Unexpected status code ${response.status}`);
      alert(`Error updating user: Unexpected status code ${response.status}`);
    }
  } catch (err) {
    console.error(`Error updating user:`, err);
    alert(`Error updating user: ${err.message}`);
  }
};

export const increaseSusLevel = async (userId) => {
  const api = useAxios();
  try {
    const res = await api.post(`/increaseSuspiciousLvlBackoffice/${userId}`);
    return res;
  } catch (err) {
    console.error(err);
    return err;
  } finally {
  }
};

export const decreaseSusLevel = async (userId) => {
  const api = useAxios();
  try {
    const res = await api.post(`/decreaseSuspiciousLvlBackoffice/${userId}`);
    return res;
  } catch (err) {
    console.error(err);
    return err;
  }
};

export const blockPlayer = async (userId) => {
  const api = useAxios();
  try {
    const res = await api.post(`/blockPlayerBackoffice/${userId}`);
    return res;
  } catch (err) {
    console.error(err);
    return err;
  }
};

export const unblockPlayer = async (userId) => {
  const api = useAxios();
  try {
    const res = await api.post(`/unblockPlayerBackoffice/${userId}`);
    return res;
  } catch (err) {
    console.error(err);
    return err;
  }
};
